import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/AppLauncher/app-launcher';
import { DropdownItem } from '../Dropdown';
import { ApplicationLauncherContent } from './ApplicationLauncherContent';
import { ApplicationLauncherContext } from './ApplicationLauncherContext';
import { ApplicationLauncherItemContext } from './ApplicationLauncherItemContext';
import StarIcon from '@patternfly/react-icons/dist/js/icons/star-icon';
export var ApplicationLauncherItem = function ApplicationLauncherItem(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      id = _a.id,
      children = _a.children,
      _a$icon = _a.icon,
      icon = _a$icon === void 0 ? null : _a$icon,
      _a$isExternal = _a.isExternal,
      isExternal = _a$isExternal === void 0 ? false : _a$isExternal,
      href = _a.href,
      _a$tooltip = _a.tooltip,
      tooltip = _a$tooltip === void 0 ? null : _a$tooltip,
      _a$tooltipProps = _a.tooltipProps,
      tooltipProps = _a$tooltipProps === void 0 ? null : _a$tooltipProps,
      _a$component = _a.component,
      component = _a$component === void 0 ? 'a' : _a$component,
      _a$isFavorite = _a.isFavorite,
      isFavorite = _a$isFavorite === void 0 ? null : _a$isFavorite,
      _a$ariaIsFavoriteLabe = _a.ariaIsFavoriteLabel,
      ariaIsFavoriteLabel = _a$ariaIsFavoriteLabe === void 0 ? 'starred' : _a$ariaIsFavoriteLabe,
      _a$ariaIsNotFavoriteL = _a.ariaIsNotFavoriteLabel,
      ariaIsNotFavoriteLabel = _a$ariaIsNotFavoriteL === void 0 ? 'not starred' : _a$ariaIsNotFavoriteL,
      customChild = _a.customChild,
      _a$enterTriggersArrow = _a.enterTriggersArrowDown,
      enterTriggersArrowDown = _a$enterTriggersArrow === void 0 ? false : _a$enterTriggersArrow,
      props = __rest(_a, ["className", "id", "children", "icon", "isExternal", "href", "tooltip", "tooltipProps", "component", "isFavorite", "ariaIsFavoriteLabel", "ariaIsNotFavoriteLabel", "customChild", "enterTriggersArrowDown"]);

  return React.createElement(ApplicationLauncherItemContext.Provider, {
    value: {
      isExternal: isExternal,
      icon: icon
    }
  }, React.createElement(ApplicationLauncherContext.Consumer, null, function (_ref) {
    var onFavorite = _ref.onFavorite;
    return React.createElement(DropdownItem, Object.assign({
      id: id,
      component: component,
      href: href || null,
      className: css(isExternal && styles.modifiers.external, isFavorite !== null && styles.modifiers.link, className),
      listItemClassName: css(onFavorite && styles.appLauncherMenuWrapper, isFavorite && styles.modifiers.favorite),
      tooltip: tooltip,
      tooltipProps: tooltipProps
    }, enterTriggersArrowDown === true && {
      enterTriggersArrowDown: enterTriggersArrowDown
    }, customChild && {
      customChild: customChild
    }, isFavorite !== null && {
      additionalChild: React.createElement("button", {
        className: css(styles.appLauncherMenuItem, styles.modifiers.action),
        "aria-label": isFavorite ? ariaIsFavoriteLabel : ariaIsNotFavoriteLabel,
        onClick: function onClick() {
          onFavorite(id, isFavorite);
        }
      }, React.createElement(StarIcon, null))
    }, props), children && React.createElement(ApplicationLauncherContent, null, children));
  }));
};